import React from 'react'
import Card from '../../../components/common/Card'
import Badge from '../../../components/ui/badge/Badge'

const ProductResume = () => {
    return (
        <Card>
            <div className='space-y-6 text-gray-800 dark:text-white/90'>
                {/* Geral */}
                <div className='space-y-2 text-sm'>
                    <div className='flex items-center'>
                        <img
                            className='w-14 h-14 rounded-full mr-3'
                            src='https://flowbite.com/docs/images/people/profile-picture-5.jpg'
                            alt='user photo'
                        />
                        <div>
                            <h2 className='font-bold text-lg'>Roberto Delavi</h2>
                            <p className='text-sm'>(Tony)</p>
                        </div>
                    </div>
                    <p>RDA Soluções Web</p>
                    <p>roberto.delavy@gmail.com</p>
                    <p>(123) 456-7890</p>
                    <p>Rua Euclides Prade 465E</p>
                </div>

                {/* Etiquetas */}
                <div className='space-y-1'>
                    <h4 className='text-lg font-bold text-gray-800 dark:text-white/90'>Etiquetas</h4>
                    <div className='text-sm space-x-1'>
                        <Badge color='warning'>Rádio</Badge>
                        <Badge color='success'>Campanha Hotmart</Badge>
                    </div>
                </div>

                {/* Descrição */}
                <div className='space-y-1'>
                    <h4 className='text-lg font-bold text-gray-800 dark:text-white/90'>Descrição</h4>
                    <p className='text-sm'>
                        Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of
                        classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a
                        Latin professor at Hampden-Sydney College in Virginia.
                    </p>
                </div>

                {/* Última modificação */}
                <p className='text-xs opacity-50'>Última modificação em Hoje, 09:45</p>
            </div>
        </Card>
    )
}

export default ProductResume
